import { useEffect, useRef, useState } from 'react';
export const usePopoverWidth = (defaultWidth) => {
    const [width, setWidth] = useState(defaultWidth !== null && defaultWidth !== void 0 ? defaultWidth : 200);
    const targetRef = useRef(null);
    useEffect(() => {
        const observer = new ResizeObserver((entries) => {
            setWidth(entries[0].borderBoxSize[0].inlineSize);
        });
        if (targetRef.current) {
            observer.observe(targetRef.current);
            const { width } = targetRef.current.getBoundingClientRect();
            setWidth(width);
        }
        return () => observer.disconnect();
    }, []);
    return [targetRef, width];
};
